import {useCallback} from 'react'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import useNavigation from '@salesforce/retail-react-app/app/hooks/use-navigation'

//The useProductRegistrationHandler hook provides a function to handle product registration clicks based on the user's locale.
//If the locale has a productRegistrationLink, it opens the external productRegistrationLink URL for product registration.
//Otherwise, it navigates to a specified internal path or the default /product-registration.

const useProductRegistrationHandler = (
    routingObject,
    customNavigateLink = routingObject?.PRODUCT_REGISTRATION_PATH,
) => {
    const {locale} = useMultiSite()
    const navigate = useNavigation()

    const handleProductRegistrationClick = useCallback(() => {
        const productRegistrationLink = locale?.productRegistrationLink

        if (productRegistrationLink) {
            window.open(productRegistrationLink, '_blank', 'noopener,noreferrer')
        } else {
            navigate(customNavigateLink)
        }
    }, [locale, customNavigateLink])

    return handleProductRegistrationClick
}

export default useProductRegistrationHandler
